import DisablableHeaderActionButton from './DisablableHeaderActionButton'
import {
  UseCheckPermissionsMapItem,
  useCheckPermissionsMap,
} from 'hooks/useCheckPermission'
import { useCIMSTableContext } from '../../../CIMSTableContext'
import CIMSLink from '../../../../CIMSLink'
import { Popconfirm } from 'antd'
import type { HeaderActionPlacement } from '../../../CIMSTableContext/types/actions/header'

interface CustomHeaderActionButtonsProps {
  placement?: HeaderActionPlacement
}

function CustomHeaderActionButtons<T extends object>({
  placement = 'left',
}: CustomHeaderActionButtonsProps) {
  const { dataSource, actions } = useCIMSTableContext<T>()
  const custom = actions.header.custom ?? []
  const [map] = useCheckPermissionsMap(
    custom.reduce((customs, custom, key) => {
      if ((custom.placement ?? 'left') !== placement) return customs
      if (custom.type === 'externalLink') return customs
      const { permission } = custom
      if (typeof permission === 'function')
        customs.push({ key, permission, record: dataSource })
      else customs.push({ key, permission })
      return customs
    }, Array<UseCheckPermissionsMapItem<T, number>>())
  )
  return (
    <>
      {custom.map((custom, i) => {
        if ((custom.placement ?? 'left') !== placement) return null
        if (custom.type === 'externalLink') {
          const { type: _, label, placement: _placement, ...rest } = custom
          return (
            <CIMSLink key={`externalLink-${i}`} external {...rest}>
              {label}
            </CIMSLink>
          )
        }
        const {
          confirm,
          text,
          permission: _permission,
          placement: _placement,
          ...rest
        } = custom
        if (!map.get(i)) return null
        const button = (
          <DisablableHeaderActionButton key={`actionButton-${i}`} {...rest}>
            {text}
          </DisablableHeaderActionButton>
        )

        return confirm ? (
          <Popconfirm {...confirm} key={`confirmButton-${i}`}>
            {button}
          </Popconfirm>
        ) : (
          button
        )
      })}
    </>
  )
}

export default CustomHeaderActionButtons
